var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.visible,
        width: "800px",
        top: "5vh",
        "close-on-click-modal": false,
        "custom-class": "bond-form-dialog"
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          staticClass: "bond-form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-position": "top" }
        },
        [
          _c("div", { staticClass: "form-section" }, [
            _c("div", { staticClass: "section-title" }, [_vm._v("进口商信息")]),
            _c("div", { staticClass: "sub-section-title" }, [
              _vm._v("主体信息")
            ]),
            _c(
              "div",
              { staticClass: "field-group" },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "合作清关行",
                              prop: "customsBrokerId"
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请输入清关行名称搜索",
                                  filterable: "",
                                  remote: "",
                                  clearable: "",
                                  "reserve-keyword": "",
                                  "remote-method": _vm.searchCustomsBrokers,
                                  loading: _vm.brokerLoading
                                },
                                on: {
                                  change: _vm.handleBrokerChange,
                                  clear: _vm.handleBrokerClear,
                                  "visible-change":
                                    _vm.handleBrokerVisibleChange
                                },
                                nativeOn: {
                                  input: function($event) {
                                    return _vm.handleBrokerSearchInput($event)
                                  }
                                },
                                model: {
                                  value: _vm.form.customsBrokerId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "customsBrokerId", $$v)
                                  },
                                  expression: "form.customsBrokerId"
                                }
                              },
                              [
                                _vm._l(_vm.customsBrokers, function(item) {
                                  return _c("el-option", {
                                    key: item.cmpIdx,
                                    attrs: {
                                      label: item.chineseName,
                                      value: item.cmpIdx
                                    }
                                  })
                                }),
                                _vm.brokerHasMore
                                  ? _c(
                                      "div",
                                      { staticClass: "load-more-tip" },
                                      [_vm._v("滚动到底部加载更多...")]
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "Importer No", prop: "importerNo" }
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入Importer No" },
                              model: {
                                value: _vm.form.importerNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "importerNo", $$v)
                                },
                                expression: "form.importerNo"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "进口商名称", prop: "importerName" }
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入进口商名称" },
                              model: {
                                value: _vm.form.importerName,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "importerName", $$v)
                                },
                                expression: "form.importerName"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("div", { staticClass: "sub-section-title" }, [
                  _vm._v("实际经营地址（美国）")
                ]),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "洲/省", prop: "operatingState" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择",
                                  filterable: "",
                                  clearable: ""
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.handleStateChange("operating")
                                  },
                                  clear: function($event) {
                                    return _vm.handleStateClear("operating")
                                  }
                                },
                                model: {
                                  value: _vm.form.operatingState,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "operatingState", $$v)
                                  },
                                  expression: "form.operatingState"
                                }
                              },
                              _vm._l(_vm.usStates, function(item) {
                                return _c("el-option", {
                                  key: item.stateCode,
                                  attrs: {
                                    label: item.stateName,
                                    value: item.stateName
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "城市", prop: "operatingCity" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择",
                                  filterable: "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.form.operatingCity,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "operatingCity", $$v)
                                  },
                                  expression: "form.operatingCity"
                                }
                              },
                              _vm._l(_vm.operatingCities, function(item) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: item }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "详细街道地址",
                              prop: "operatingAddress"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入详细街道地址" },
                              model: {
                                value: _vm.form.operatingAddress,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "operatingAddress", $$v)
                                },
                                expression: "form.operatingAddress"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "sub-section-title-row" },
                  [
                    _c("span", { staticClass: "sub-section-title" }, [
                      _vm._v("邮寄地址（美国）")
                    ]),
                    _c(
                      "el-checkbox",
                      {
                        on: { change: _vm.handleMailingSame },
                        model: {
                          value: _vm.form.mailingSame,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "mailingSame", $$v)
                          },
                          expression: "form.mailingSame"
                        }
                      },
                      [_vm._v("和实际地址保持一致")]
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "洲/省", prop: "mailingState" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择",
                                  disabled: _vm.form.mailingSame,
                                  filterable: "",
                                  clearable: ""
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.handleStateChange("mailing")
                                  },
                                  clear: function($event) {
                                    return _vm.handleStateClear("mailing")
                                  }
                                },
                                model: {
                                  value: _vm.form.mailingState,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "mailingState", $$v)
                                  },
                                  expression: "form.mailingState"
                                }
                              },
                              _vm._l(_vm.usStates, function(item) {
                                return _c("el-option", {
                                  key: item.stateCode,
                                  attrs: {
                                    label: item.stateName,
                                    value: item.stateName
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "城市", prop: "mailingCity" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择",
                                  disabled: _vm.form.mailingSame,
                                  filterable: "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.form.mailingCity,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "mailingCity", $$v)
                                  },
                                  expression: "form.mailingCity"
                                }
                              },
                              _vm._l(_vm.mailingCities, function(item) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: item }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "详细街道地址",
                              prop: "mailingAddress"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入详细街道地址",
                                disabled: _vm.form.mailingSame
                              },
                              model: {
                                value: _vm.form.mailingAddress,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "mailingAddress", $$v)
                                },
                                expression: "form.mailingAddress"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("div", { staticClass: "sub-section-title filing-title" }, [
              _vm._v("备案信息")
            ]),
            _c(
              "div",
              { staticClass: "field-group" },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "法人/授权负责人姓名",
                              prop: "legalPersonName"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入法人/授权负责人姓名"
                              },
                              model: {
                                value: _vm.form.legalPersonName,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "legalPersonName", $$v)
                                },
                                expression: "form.legalPersonName"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "联系电话", prop: "contactPhone" }
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入联系电话" },
                              model: {
                                value: _vm.form.contactPhone,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "contactPhone", $$v)
                                },
                                expression: "form.contactPhone"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "Email", prop: "email" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入Email" },
                              model: {
                                value: _vm.form.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "email", $$v)
                                },
                                expression: "form.email"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "EIN税号", prop: "einTaxNo" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入EIN税号" },
                              model: {
                                value: _vm.form.einTaxNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "einTaxNo", $$v)
                                },
                                expression: "form.einTaxNo"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "ACE 用户名", prop: "aceUsername" }
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入ACE用户名" },
                              model: {
                                value: _vm.form.aceUsername,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "aceUsername", $$v)
                                },
                                expression: "form.aceUsername"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "ACE 密码", prop: "acePassword" } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入ACE密码",
                                type: "password",
                                "show-password": ""
                              },
                              model: {
                                value: _vm.form.acePassword,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "acePassword", $$v)
                                },
                                expression: "form.acePassword"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "form-section" }, [
            _c("div", { staticClass: "section-title" }, [
              _vm._v("美国清关Bond核心信息")
            ]),
            _c(
              "div",
              { staticClass: "field-group" },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "Bond类型", prop: "bondType" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "请选择" },
                                model: {
                                  value: _vm.form.bondType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "bondType", $$v)
                                  },
                                  expression: "form.bondType"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: "年度Continuous Bond",
                                    value: "1"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: { label: "单次STB Bond", value: "2" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "Bond编号", prop: "bondNo" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入Bond编号" },
                              model: {
                                value: _vm.form.bondNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "bondNo", $$v)
                                },
                                expression: "form.bondNo"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "担保公司/人", prop: "guarantor" }
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入担保公司/人" },
                              model: {
                                value: _vm.form.guarantor,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "guarantor", $$v)
                                },
                                expression: "form.guarantor"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "备案港口", prop: "registerPorts" }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请输入港口名称搜索",
                                  filterable: "",
                                  remote: "",
                                  clearable: "",
                                  multiple: "",
                                  "collapse-tags": "",
                                  "reserve-keyword": "",
                                  "remote-method": _vm.searchSeaPorts,
                                  loading: _vm.seaPortLoading
                                },
                                on: {
                                  "visible-change":
                                    _vm.handleSeaPortVisibleChange,
                                  clear: _vm.handleSeaPortClear
                                },
                                nativeOn: {
                                  input: function($event) {
                                    return _vm.handleSeaPortSearchInput($event)
                                  }
                                },
                                model: {
                                  value: _vm.form.registerPorts,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "registerPorts", $$v)
                                  },
                                  expression: "form.registerPorts"
                                }
                              },
                              [
                                _vm._l(_vm.seaPorts, function(item) {
                                  return _c("el-option", {
                                    key: item.code,
                                    attrs: {
                                      label:
                                        item.code +
                                        " " +
                                        (item.chineseName || item.englishName),
                                      value: item.code
                                    }
                                  })
                                }),
                                _vm.seaPortHasMore
                                  ? _c(
                                      "div",
                                      { staticClass: "load-more-tip" },
                                      [_vm._v("滚动到底部加载更多...")]
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Bond金额(USD)",
                              prop: "bondAmount"
                            }
                          },
                          [
                            _c("el-input-number", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请输入Bond金额",
                                precision: 2,
                                step: 0.01,
                                min: 0
                              },
                              model: {
                                value: _vm.form.bondAmount,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "bondAmount", $$v)
                                },
                                expression: "form.bondAmount"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "生效日期", prop: "effectiveDate" }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "date",
                                placeholder: "请选择生效日期",
                                "value-format": "yyyy/MM/dd"
                              },
                              model: {
                                value: _vm.form.effectiveDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "effectiveDate", $$v)
                                },
                                expression: "form.effectiveDate"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "到期日期", prop: "expiryDate" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "date",
                                placeholder: "请选择到期日期",
                                "value-format": "yyyy/MM/dd"
                              },
                              model: {
                                value: _vm.form.expiryDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "expiryDate", $$v)
                                },
                                expression: "form.expiryDate"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.isEdit && _vm.expiryDateChanged
                  ? _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "续保修订说明",
                                  prop: "renewalDesc"
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    rows: 2,
                                    placeholder: "请输入续保修订说明"
                                  },
                                  model: {
                                    value: _vm.form.renewalDesc,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "renewalDesc", $$v)
                                    },
                                    expression: "form.renewalDesc"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "form-section" },
            [
              _c("div", { staticClass: "section-title" }, [
                _vm._v("附件与内部备注")
              ]),
              _c("el-form-item", { attrs: { label: "上传Bond合同文件" } }, [
                _c(
                  "div",
                  { staticClass: "upload-area" },
                  [
                    _c(
                      "el-upload",
                      {
                        attrs: {
                          action: "",
                          "http-request": _vm.customUpload,
                          "on-change": _vm.handleFileChange,
                          "before-upload": _vm.beforeUpload,
                          multiple: "",
                          "show-file-list": false
                        }
                      },
                      [
                        _c("div", { staticClass: "upload-btn" }, [
                          _c("i", { staticClass: "el-icon-plus" }),
                          _c("span", [
                            _vm._v(
                              "+ 添加附件(备注:当前支持PDF、WORD、EXCEL、TXT、JPG文件格式)"
                            )
                          ])
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm.fileList.length > 0
                  ? _c(
                      "div",
                      { staticClass: "file-list" },
                      _vm._l(_vm.fileList, function(file, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "file-item" },
                          [
                            _c("span", { staticClass: "file-name" }, [
                              file.status === "uploading"
                                ? _c("i", { staticClass: "el-icon-loading" })
                                : _vm._e(),
                              _vm._v(" " + _vm._s(file.name) + " ")
                            ]),
                            file.status === "success"
                              ? _c(
                                  "span",
                                  { staticClass: "file-actions" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "primary",
                                          plain: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.downloadFile(file)
                                          }
                                        }
                                      },
                                      [_vm._v("下载")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "primary",
                                          plain: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.previewFile(file)
                                          }
                                        }
                                      },
                                      [_vm._v("预览")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini", type: "danger" },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeFile(file, index)
                                          }
                                        }
                                      },
                                      [_vm._v("删除")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "内部通用备注", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "对接人、客户特殊要求等通用备注"
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("bond-preview-dialog", {
        attrs: {
          visible: _vm.previewVisible,
          "file-id": _vm.previewFileId,
          "file-name": _vm.previewFileName,
          "file-format": _vm.previewFileFormat
        },
        on: {
          "update:visible": function($event) {
            _vm.previewVisible = $event
          }
        }
      }),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handleCancel } }, [
            _vm._v("取消")
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSave } },
            [_vm._v("保存")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }